import { useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import logger from '@cash-web/shared/util-logger'
import { useJourneyContext } from '@cash-web/shared-journey-data-access-context'

export const JourneyNotFound = () => {
  const journey = useJourneyContext()
  const location = useLocation()
  useEffect(() => {
    journey.cancel()
    logger.error(new Error('Error: Journey not found ' + location.pathname))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}
